export const STATEMENT_QUESTION =
  'In meetings, I prepare what to say - then someone else says it first.'
